export default {"src":"/_next/static/media/BgMasqueHaut.f47d4de9.svg","height":2421,"width":8192};